import { render, staticRenderFns } from "./CommunicationRecords.vue?vue&type=template&id=5d35c320&scoped=true&"
import script from "./CommunicationRecords.vue?vue&type=script&lang=js&"
export * from "./CommunicationRecords.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationRecords.vue?vue&type=style&index=0&id=5d35c320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35c320",
  null
  
)

export default component.exports